<template>
  <div class="settings-container">

    <el-form ref="settingsForm" :model="settingsForm" label-width="120px" class="settings-form">
      <!-- 基本设置 -->
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>基本设置</span>
        </div>

        <el-form-item label="小程序AppID">
          <el-input v-model="settingsForm.miniProgramAppId" placeholder="请输入小程序AppID"></el-input>
        </el-form-item>

        <el-form-item label="小程序Secret">
          <el-input v-model="settingsForm.miniProgramSecret" placeholder="请输入小程序Secret" show-password></el-input>
        </el-form-item>

        <el-form-item label="Security ID">
          <el-input v-model="settingsForm.securityId" placeholder="请输入Security ID"></el-input>
        </el-form-item>

        <el-form-item label="服务器地址">
          <el-input v-model="settingsForm.serverUrl" placeholder="请输入服务器地址"></el-input>
          <p class="form-tip">例如：https://api.yourdomain.com</p>
        </el-form-item>
      </el-card>

      <!-- 协议设置 -->
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>协议设置</span>
        </div>

        <el-form-item label="用户协议">
          <el-upload
              class="upload-demo"
              action="#"
              :limit="1"
              :file-list="settingsForm.userAgreementFiles"
              :auto-upload="false"
              :on-change="handleUserAgreementChange"
              :on-remove="handleUserAgreementRemove"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传pdf/doc/docx文件，且不超过10MB</div>
          </el-upload>
          <div v-if="settingsForm.userAgreementContent" class="agreement-preview">
            <h4>当前用户协议内容：</h4>
            <div class="content-box">{{ settingsForm.userAgreementContent }}</div>
          </div>
        </el-form-item>

        <el-form-item label="隐私协议">
          <el-upload
              class="upload-demo"
              action="#"
              :limit="1"
              :file-list="settingsForm.privacyPolicyFiles"
              :auto-upload="false"
              :on-change="handlePrivacyPolicyChange"
              :on-remove="handlePrivacyPolicyRemove"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传pdf/doc/docx文件，且不超过10MB</div>
          </el-upload>
          <div v-if="settingsForm.privacyPolicyContent" class="agreement-preview">
            <h4>当前隐私协议内容：</h4>
            <div class="content-box">{{ settingsForm.privacyPolicyContent }}</div>
          </div>
        </el-form-item>
      </el-card>

      <!-- 其他设置 -->
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>其他设置</span>
        </div>

        <el-form-item label="系统名称">
          <el-input v-model="settingsForm.systemName" placeholder="请输入系统名称"></el-input>
        </el-form-item>

        <el-form-item label="版权信息">
          <el-input v-model="settingsForm.copyrightInfo" placeholder="请输入版权信息"></el-input>
        </el-form-item>

        <el-form-item label="备案号">
          <el-input v-model="settingsForm.icpNumber" placeholder="请输入备案号"></el-input>
        </el-form-item>
      </el-card>

      <el-form-item class="submit-btn">
        <el-button type="primary" @click="submitSettings">保存设置</el-button>
        <el-button @click="resetSettings">恢复默认</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'MobileSettings',
  data() {
    return {
      settingsForm: {
        miniProgramAppId: 'wx1234567890abcdef',
        miniProgramSecret: '',
        securityId: 'sec_1234567890',
        serverUrl: 'https://api.example.com',
        systemName: 'Template管理系统',
        copyrightInfo: '© 2023 某某公司 版权所有',
        icpNumber: '京ICP备12345678号',
        userAgreementFiles: [],
        privacyPolicyFiles: [],
        userAgreementContent: '这里是用户协议的内容示例。用户在使用本系统前，请仔细阅读本协议内容。',
        privacyPolicyContent: '这里是隐私协议的内容示例。我们非常重视用户的隐私保护。'
      },
      defaultSettings: {
        miniProgramAppId: '',
        miniProgramSecret: '',
        securityId: '',
        serverUrl: '',
        systemName: '',
        copyrightInfo: '',
        icpNumber: '',
        userAgreementFiles: [],
        privacyPolicyFiles: [],
        userAgreementContent: '',
        privacyPolicyContent: ''
      }
    }
  },
  methods: {
    // 处理用户协议文件变化
    handleUserAgreementChange(file, fileList) {
      if (fileList.length > 0) {
        this.settingsForm.userAgreementFiles = [fileList[fileList.length - 1]] // 只保留最后一个文件
        this.mockParseAgreementFile('userAgreement')
      }
    },

    // 移除用户协议文件
    handleUserAgreementRemove() {
      this.settingsForm.userAgreementFiles = []
      this.settingsForm.userAgreementContent = ''
    },

    // 处理隐私协议文件变化
    handlePrivacyPolicyChange(file, fileList) {
      if (fileList.length > 0) {
        this.settingsForm.privacyPolicyFiles = [fileList[fileList.length - 1]] // 只保留最后一个文件
        this.mockParseAgreementFile('privacyPolicy')
      }
    },

    // 移除隐私协议文件
    handlePrivacyPolicyRemove() {
      this.settingsForm.privacyPolicyFiles = []
      this.settingsForm.privacyPolicyContent = ''
    },

    // 模拟解析协议文件内容
    mockParseAgreementFile(type) {
      // 这里模拟解析上传的文件内容
      setTimeout(() => {
        if (type === 'userAgreement') {
          this.settingsForm.userAgreementContent = `这是从${this.settingsForm.userAgreementFiles[0].name}解析出的用户协议内容。\n\n1. 用户权利与义务\n2. 使用规则\n3. 免责条款\n4. 其他约定`
        } else {
          this.settingsForm.privacyPolicyContent = `这是从${this.settingsForm.privacyPolicyFiles[0].name}解析出的隐私协议内容。\n\n1. 信息收集范围\n2. 信息使用方式\n3. 信息保护措施\n4. 用户权利`
        }
        this.$message.success(`${type === 'userAgreement' ? '用户协议' : '隐私协议'}文件已解析`)
      }, 1000)
    },

    // 提交设置
    submitSettings() {
      this.$refs.settingsForm.validate(valid => {
        if (valid) {
          // 模拟保存设置
          this.$message.success('设置保存成功')
          console.log('保存的设置:', JSON.stringify(this.settingsForm, null, 2))

          // 这里实际项目中应该调用API保存设置
          // this.saveSettingsToServer()
        } else {
          this.$message.error('请检查表单填写是否正确')
          return false
        }
      })
    },

    // 恢复默认设置
    resetSettings() {
      this.$confirm('确定要恢复默认设置吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.settingsForm = JSON.parse(JSON.stringify(this.defaultSettings))
        this.$message.success('已恢复默认设置')
      })
    },

    // 模拟从服务器获取设置
    fetchSettingsFromServer() {
      // 这里模拟从服务器获取设置
      setTimeout(() => {
        // 实际项目中应该替换为API调用
        // this.settingsForm = response.data
        this.$message.success('设置加载完成')
      }, 800)
    }
  },
  created() {
    this.fetchSettingsFromServer()
  }
}
</script>

<style scoped>
.settings-container {
  padding: 20px;
}

.settings-title {
  margin-bottom: 30px;
  color: #303133;
}

.settings-form {
  max-width: 100vw;
}

.box-card {
  margin-bottom: 20px;
}

.form-tip {
  margin: 0;
  font-size: 12px;
  color: #909399;
}

.agreement-preview {
  margin-top: 15px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.agreement-preview h4 {
  margin-top: 0;
  margin-bottom: 10px;
  color: #606266;
}

.content-box {
  max-height: 200px;
  overflow-y: auto;
  padding: 10px;
  background-color: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  white-space: pre-line;
}

.submit-btn {
  margin-top: 30px;
  text-align: center;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .settings-form {
    padding: 15px;
  }

  .box-card {
    margin-bottom: 15px;
  }

  .content-box {
    max-height: 150px;
  }
}

@media (max-width: 576px) {
  .settings-title {
    font-size: 20px;
    margin-bottom: 20px;
  }

  .settings-form {
    padding: 10px;
  }
}
</style>